import { useMemo } from "react";
import { FLAT_RATE_PLANS } from "@common/flatRateBilling";
import { FlatRatePlan } from "@common/schemas/billing.schema";

export type AdvancedEnterprisePlan =
    | FLAT_RATE_PLANS.ADVANCED
    | FLAT_RATE_PLANS.ENTERPRISE;

export const isAdvancedEnterprisePlan = (
    plan: FLAT_RATE_PLANS | null | undefined,
): plan is AdvancedEnterprisePlan =>
    plan === FLAT_RATE_PLANS.ADVANCED || plan === FLAT_RATE_PLANS.ENTERPRISE;

export const useAdvancedEnterpriseToggle = (plans: FlatRatePlan[]) => {
    const hasBothPlans =
        plans.some(({ plan }) => plan === FLAT_RATE_PLANS.ADVANCED) &&
        plans.some(({ plan }) => plan === FLAT_RATE_PLANS.ENTERPRISE);

    const visiblePlans = useMemo(
        () =>
            hasBothPlans
                ? plans.filter(
                      ({ plan }) =>
                          !isAdvancedEnterprisePlan(plan) ||
                          plan === FLAT_RATE_PLANS.ADVANCED,
                  )
                : plans,
        [hasBothPlans, plans],
    );

    return { visiblePlans };
};
